import MinersStatuses from "@components/global/new/MinersStatuses/MinersStatuses";
import mainLocationsStore from "@mobx/store/locations";
import { MinerStatusInModal } from "@mobx/store/locations/types";

const BuildingMiners3 = () => {
  const locationStore = mainLocationsStore?.activeLocation;
  const buildingStore = locationStore?.activeBuilding;

  const onOpenModal = (status: MinerStatusInModal) => {
    buildingStore?.showStatusesModal(status, true);
  };

  return (
    <MinersStatuses
      ok={buildingStore?.building.m_online || 0}
      low={buildingStore?.building.m_low || 0}
      off={buildingStore?.building.m_offline || 0}
      onClickStatuses={onOpenModal}
    />
  );
}

export default BuildingMiners3;